import type { JSX } from 'react';

import { useKnownAvailableParams } from '@change-corgi/core/react/router';
import { Loader } from '@change-corgi/design-system-legacy/components/progressiveDisclosure';

import { withPrefetchedData } from 'src/shared/prefetch';

import {
	PetitionGuidesPageContextProvider,
	prefetchPageContext,
} from 'src/app/pages/petitionGuidesArticle/pageContext';
import type { PetitionGuidesPagePrefetchedDataProps } from 'src/app/pages/petitionGuidesArticle/pageContext';

import { Layout } from '../layout';

import { PetitionGuidesErrorHandler } from './ErrorHandler';

export const PetitionGuidesArticle = withPrefetchedData(
	function PetitionGuides({ prefetchedData }: PetitionGuidesPagePrefetchedDataProps): JSX.Element {
		const { slug } = useKnownAvailableParams<{ slug: string }>();

		return (
			<PetitionGuidesPageContextProvider
				slug={slug}
				prefetchedData={prefetchedData}
				errorHandler={PetitionGuidesErrorHandler}
				loadingFallback={<Loader size="m" my={256} mx="auto" />}
			>
				<Layout />
			</PetitionGuidesPageContextProvider>
		);
	},
	{
		prefetchName: __MODULE_HASH__,
		// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
		prefetchData: async (context) => prefetchPageContext(context.params.slug!, context),
	},
);
